import { render } from "./DashboardPage.vue?vue&type=template&id=6a9a3467"
import script from "./DashboardPage.vue?vue&type=script&lang=js"
export * from "./DashboardPage.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./DashboardPage.vue?vue&type=style&index=0&id=6a9a3467&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__